var map = {
	"./BG_WALLET_MODO.png": 184,
	"./BG_WALLET_PAYDISS.png": 185,
	"./modo.png": 132,
	"./paydiss.png": 369,
	"./wallet.png": 75,
	"./wallets_virt.png": 186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 368;